var StoreLocations = ( state = [], action ) => {
    if ( action.type === 'locations' ) {
        return action.payload
    } else {
        return state
    }
}
export default StoreLocations;